<template>
  <div class="dashboard">

    <template v-if="remove_modal">
      <div class="modal">
        <div class="modal-wrapper">
          <div>
            <a class="close" v-on:click="remove_modal = false"></a>
          </div>
          <div class="modal-form">
            <form v-on:submit.prevent="remove(remove_modal)">
              <h1 v-html="$root.t(`dashboard:removemodal:title`)"></h1>
              <p v-html="$root.t(`dashboard:removemodal:text`)"></p>
              <input type="submit" :value="$root.t('dashboard:removemodal:submit')">
            </form>
          </div>
        </div>
      </div>
    </template>


    <template v-if="add_modal">
      <div class="modal">
        <div class="modal-wrapper">
          <div>
            <a class="close" v-on:click="add_modal = false"></a>
          </div>
          <div class="modal-form">
              <h1 v-html="$root.t(`dashboard:addmodal:title`)"></h1>
              <form v-on:submit.prevent="addnew()">
                  <div class="extended_field">
                      <label :class="{'alert': add_modal_alert.title}" v-html="$root.t('dashboard:addmodal:label:title')">
                      </label>
                      <input v-model="add_modal_data.title" type="text" name="titel">
                  </div>
                  <div class="extended_field">
                      <label :class="{'alert': add_modal_alert.mediatype}" v-html="$root.t('dashboard:addmodal:label:typ')">
                      </label>
                      <div class="select-wrapper">
                        <select v-model="add_modal_data.mediatype" v-on:change="checkRoles()">
                          <option v-for="c in chapters" v-bind:value="c" v-html="c.translation"></option>
                        </select>
                      </div>
                  </div>                      
                  <div class="extended_field" v-if="add_modal_data.mediatype && add_modal_data.mediatype.roles && add_modal_data.mediatype.roles.length > 1">
                      <label :class="{'alert': add_modal_alert.role}" v-html="$root.t('dashboard:addmodal:label:role')">
                      </label>
                      <p class="checkbox" v-for="c in add_modal_data.mediatype.roles">
                        <label>
                        <input v-bind:value="c.id" v-html="c.translation" type="checkbox" v-model="add_modal_data.role"/>
                        <span v-html="c.translation"></span>
                        </label>
                      </p>
                  </div>                      

                  <input type="submit" :value="$root.t('dashboard:addmodal:submit')">
              </form>
          </div>
        </div>
      </div>
    </template>

    <StaticHeader v-bind:title="$root.t('dashboard:title')"/>
    <div class="container container-nopaddinghorizontal container-afterheader container-includestaticfooter">
      <transition name="container-overlay">
        <div class="container-overlay" v-if="searching"></div>      
      </transition>      

      <div class="container container-small container-float">
        <div class="container-column container-column-left" v-html="$root.t('dashboard:column_left')"></div>
        <div class="container-column container-column-right" v-html="$root.t('dashboard:column_right')"></div>
      </div>

      <div class="container container-small" v-if="form_data">

        <h3>{{$root.t('dashboard:titlepart')}} {{author.vorname}} {{author.name}}</h3>

        <input class="small wide" type="submit" v-on:click="open_add_modal()" :value="$root.t('dashboard:addnew')">
        <table>
          <template v-for="ref in form_data">
            <tr v-if="ref.Contribution">
              <td>
                <router-link 
                  tag="button" 
                  class="button button-nonfix"
                  :to="{name: 'editor', params: {editor: ref.Contribution.FortemplateName, id: ref.Contribution.Id}}"
                >
                  <svg id="i-edit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M30 7 L25 2 5 22 3 29 10 27 Z M21 6 L26 11 Z M5 22 L10 27 Z" />
                  </svg>
                  <span>{{$root.t('edit:bearbeiten')}}</span>
                </router-link> 
              </td>
              <td><span class="label" :class="`label-${ref.Contribution.Status}`" v-html="$root.t(`contribution:${ref.Contribution.Status}`)"></span></td>
              <td>
                <router-link 
                  tag="a" 
                  target="_blank"
                  v-bind:key="ref.Contribution.Id"
                  :to="{name: 'entry', params: {view: ref.Contribution.FortemplateName, id: ref.Contribution.Id}}"
                >
                 {{ref.Data.titel.Field.Content}}{{ref.Data.untertitel && ref.Data.untertitel.Field.Content?`, ${ref.Data.untertitel.Field.Content}`:''}}
                </router-link><br>
              </td>
              <td>
                <div>
                  <span>{{$root.t('dashboard:moddate')}}: {{ref.Contribution.Moddate | dateformat}}</span>
                  <span>{{$root.t('dashboard:newdate')}}: {{ref.Contribution.Newdate | dateformat}}</span>
                </div>
              </td>
              <td class="extended_field"> <a class="tag remove" v-on:click="remove_modal = ref"></a> </td>
            </tr>
          </template>
        </table>
  
        

      </div>

    </div>
    <StaticFooter/>
  </div>
</template>

<style lang="scss">
  @import "../main";
  .dashboard {
      table {
       width: 100%;
       border-collapse: collapse;
       margin-bottom: $padding * 3;
       tr {
         border-bottom: 1px solid;
         &:first-child {
           border-top: 1px solid;
         }
       } 
       td {
         padding: $padding 0;
         vertical-align: middle;
         @include sm() {
           vertical-align: top;
           @include smallfont();
         }
         width: auto;
         &:first-child {
           padding-right: $padding;
         }
         &:last-child {
           padding-left: $padding;
         }
         &:nth-child(4) {
           @include sm() {
             display: none;
           }
         }
         div {
           @include smallfont();
           span {
           white-space: nowrap;
           display: block;
            @include sm() {
              white-space: normal;
            }
           }
         }
       }
      }
      input {
        &.wide {
          margin: $padding*2 0;
        }
        &.small {
          width: 100%;
        }
      }
  }

</style>

<script>

import StaticHeader from '@/components/StaticHeader.vue'
import StaticFooter from '@/components/StaticFooter.vue'
import _ from 'lodash'

export default {
  name: 'profile',
  components: {
      StaticHeader,
      StaticFooter
  },
  data() {
    return {
        data: null,
        remove_modal: false,
        add_modal: false,
        add_modal_data: {
          title: "",
          mediatype: [],
          role: []
        },
        add_modal_alert: {
          title: false,
          mediatype: false,
          role: false
        },
        chapters: [
          {
            id: 4,  
            translation: this.$root.t('chapter:works:books'),
            roles: [
              {id: 'autor',  translation: this.$root.t('dashboard:roles:autor')},
              {id: 'coautor',  translation: this.$root.t('dashboard:roles:coautor')},
              {id: 'herausgeber',  translation: this.$root.t('dashboard:roles:herausgeber')},
              {id: 'uebersetzer',  translation: this.$root.t('dashboard:roles:uebersetzer')},
            ]
          },
          {
            id: 5,  
            translation: this.$root.t('chapter:works:other'),
            roles: [
              {id: 'autor',  translation: this.$root.t('dashboard:roles:other')}
            ]
          },
          {
            id: 10, 
            translation: this.$root.t('chapter:works:sekundärliteratur'),
            roles: [
              {id: 'autor',  translation: this.$root.t('dashboard:roles:sekundärliteratur')}
            ]
          }
        ],


        searching: true,
        author: false,
        form_data: false
    }
  },
  mounted() {
    if (!this.$root.logindata.token) {
      this.$root.loginmodal(this.fetchData);
    } else {
      this.fetchData()
    }
  },
  watch: {
    '$route' () {
        this.fetchData(); 
    }
  },
  methods: {
    checkRoles() {
      this.add_modal_data.role = [];
      if (this.add_modal_data.mediatype.roles.length === 1) {
        this.add_modal_data.role.push(this.add_modal_data.mediatype.roles[0].id)
      }
    },
    open_add_modal() {
      this.add_modal_data = {
        title: "",
        mediatype: [],
        role: []
      }
      this.add_modal_alert = {
        title: false,
        mediatype: false,
        role: false
      }
      this.add_modal = true;
    },
    async fetchData() {
      this.searching = true;
      this.data = await this.$store.dispatch('load', {realtime: true, mode: `/contribution/${this.$root.logindata.userid}`, params: {verbose: 'true'}});
      if (this.data.error) {
        console.warn(this.data.error);
      }
      else {
        this.form_data = this.data.Contribution.ReferencedFrom;
        this.form_data = _.orderBy(this.form_data, o => parseInt(o.Contribution.Moddate), 'desc');
        let _map = [];
        this.form_data = this.form_data.filter(o => {
          let inMap = _map.indexOf(o.Contribution.Id) !== -1;
          if (!inMap) {
            _map.push(o.Contribution.Id)
            return true;
          }
          return false;
        })
        this.author =  {name: this.data.Data.name.Field.Content, vorname: this.data.Data.vorname.Field.Content};
      }
      this.searching = false;
    },
     async addnew() {
      this.add_modal_alert.role = this.add_modal_data.role.length == 0;
      this.add_modal_alert.mediatype = this.add_modal_data.mediatype.length == 0;
      this.add_modal_alert.title = this.add_modal_data.title == "";
      if (!this.add_modal_alert.role && !this.add_modal_alert.mediatype && !this.add_modal_alert.title) {
        this.add_modal = false;
        this.searching = true;
        let result = await this.$store.dispatch('post', {
            mode: `/addmedia/${this.$root.logindata.userid}`, 
            params: this.add_modal_data
        });
        if (result.error === false) {
          this.fetchData(); 
        }
        else {
          console.warn(result);
          this.searching = false;
        }

      }
    },
    async remove(ref) {
      // Implement: Remove Contribution
      this.searching = true;
      this.remove_modal = false;
      let result = await this.$store.dispatch('post', {
        mode: `/deletemedia/${this.$root.logindata.userid}`, 
        params: ref.Contribution
      });
      this.fetchData(); 

    }
  }
}
</script>
